import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/BackendLp'

const BackendLp: React.FC = () => {
  return (
    <>
      <CustomHead
        keyword={'サーバレス　AWS クラウド　アーキテクチャ設計　GraphQL　Dokcer GO システム開発'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/services/backend-dev/'}
        title="システム開発 | Aitria（アイトリア）"
        description="Aitria（アイトリア）では、AWS活用の大規模システム開発サービスを提供。AWS、GO、Node.jsなどバックエンド開発に特化したシステム開発サービスです。最新のバックエンド技術を駆使して、一緒に大規模システムを開発しましょう。"
      />
      <Template />
    </>
  )
}

export default BackendLp
